import { render, staticRenderFns } from "./vmSelector.vue?vue&type=template&id=1df8e470&"
import script from "./vmSelector.vue?vue&type=script&lang=js&"
export * from "./vmSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports